import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.setupTurboListeners();
  }

  disconnect() {
    this.removeTurboListeners();
  }

  setupTurboListeners() {
    document.addEventListener("turbo:submit-start", function () {
      document.getElementById("loading-status").classList.remove("hidden");
    });

    document.addEventListener("turbo:submit-end", function () {
      document.getElementById("loading-status").classList.add("hidden");
    });

    // document.addEventListener("turbo:click", function () {
    //   document.getElementById("loading-status").classList.remove("hidden");
    // });

    // document.addEventListener("turbo:frame-render", function () {
    //   document.getElementById("loading-status").classList.add("hidden");
    // });
  }

  removeTurboListeners() {
    document.removeEventListener("turbo:submit-start", function () {});
    document.removeEventListener("turbo:submit-end", function () {});
    // document.removeEventListener("turbo:click", function () {});
    // document.removeEventListener("turbo:frame-render", function () {});
  }
}
